exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app[data-v-5319e2be]{background-color:#eff3f6}.app .img[data-v-5319e2be]{text-align:center;padding:.5rem 0;background-color:#fff}.app .img img[data-v-5319e2be]{height:7.125rem}.app .img h1[data-v-5319e2be]{font-size:.48rem}.app .code-tips[data-v-5319e2be]{padding:0 .5rem}.app .code-tips h3[data-v-5319e2be]{height:2rem;line-height:2rem;text-align:left;margin:0;color:#3d3d3d}.app .code-tips p[data-v-5319e2be]{color:#999a9c;word-break:break-all;line-height:1.125rem;font-size:.426667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5319e2be","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/familyDoctor/Review.vue
// module id = 448
// module chunks = 0